module.exports = __webpack_public_path__ + "static/media/career1.352741e6.jpg";